var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOosProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.902,
    height: 134.405,
    viewBox: "0 0 171.902 134.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-700.049 -420.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(743.14 420.395)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M31.44,35.88a17.305,17.305,0,0,0,1,2,17.325,17.325,0,0,0,1-2Z",
    transform: "translate(10.419 28.199)",
    fill: "#00aee0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M31.44,35.88a17.305,17.305,0,0,0,1,2,17.325,17.325,0,0,0,1-2Z",
    transform: "translate(10.419 28.199)",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M41.434,29.135c-1.322-2.412-2.767-4.8-4.276-7.144-2.518-3.857-5.131-7.465-7.411-10.433-1.519,2.215-2.983,4.358-4.322,6.573,2.661,3.571,5.251,7.341,7.483,11A77.992,77.992,0,0,1,37.159,37a24.18,24.18,0,0,1,2.625,9.268,22.162,22.162,0,0,1-1.644,8.661,17.326,17.326,0,0,1-.982,2.052A19.287,19.287,0,0,0,42,62.873c.342,0,.393-.214.893-.946a25.654,25.654,0,0,0,3.571-8.8,32.823,32.823,0,0,0,.7-6.858C47.167,41.314,44.737,35.187,41.434,29.135Z",
    transform: "translate(5.694 9.087)",
    fill: "#a12697"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M40.852,18.275l.144-.2c-1.339-2.16-2.839-4.358-4.322-6.518l-1.142,1.5a43.985,43.985,0,0,1,5.322,5.215Z",
    transform: "translate(13.635 9.088)",
    fill: "#fc8030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M40.852,18.275l.144-.2c-1.339-2.16-2.839-4.358-4.322-6.518l-1.142,1.5a43.985,43.985,0,0,1,5.322,5.215Z",
    transform: "translate(13.635 9.088)",
    opacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M25.574,18.305l-.144-.2c1.339-2.215,2.8-4.358,4.322-6.518l1.142,1.5A43.985,43.985,0,0,0,25.572,18.3Z",
    transform: "translate(5.697 9.111)",
    opacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M38.3,12.4c-2,2.661-4.2,5.714-6.3,8.929,1.5,2.3,2.947,4.7,4.276,7.144,2.2-3.571,4.732-7.322,7.375-10.859A43.985,43.985,0,0,0,38.3,12.4Z",
    transform: "translate(10.86 9.748)",
    fill: "#fc8030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M34.25,29.267A77.99,77.99,0,0,0,29.975,21.4l-.357.66-.482.912a47.415,47.415,0,0,1,5.107,6.393Z",
    transform: "translate(8.609 16.82)",
    fill: "#fc8030"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M34.25,29.267A77.99,77.99,0,0,0,29.975,21.4l-.357.66-.482.912a47.415,47.415,0,0,1,5.107,6.393Z",
    transform: "translate(8.609 16.82)",
    opacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M55.584,8.464,53.532,6.143a.946.946,0,0,0-1.428,0L50.031,8.464l-1.392,1.625c1.881,2.589,3.822,5.358,5.661,8.394,8.589,10.876,17.573,24.77,17.573,32.306,0,11.751-7.3,19.054-19.054,19.054a20.715,20.715,0,0,1-11.072-2.822l-.65-.445a15.8,15.8,0,0,1-4.715-5.071,17.31,17.31,0,0,1-1-2,22.162,22.162,0,0,1-1.625-8.722,23.966,23.966,0,0,1,2.625-9.143h0a47.415,47.415,0,0,0-5.054-6.393c-2.875,5.536-4.91,11.054-4.91,15.644a32.824,32.824,0,0,0,.715,6.786A25.68,25.68,0,0,0,30.708,66.5a3.291,3.291,0,0,0,.41.59,22.448,22.448,0,0,0,5.36,5.358,27.707,27.707,0,0,0,16.429,4.857c15.966-.036,26.338-10.446,26.338-26.52C79.248,36,58.013,11.25,55.584,8.464Z",
    transform: "translate(6.474 4.575)",
    fill: "#fc8030"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M33.889,46.085l.893-.607a22.447,22.447,0,0,1-5.358-5.358l-.965.554a13.3,13.3,0,0,0,5.428,5.411Z",
    transform: "translate(8.078 31.531)",
    fill: "#a12697"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M33.889,46.085l.893-.607a22.447,22.447,0,0,1-5.358-5.358l-.965.554a13.3,13.3,0,0,0,5.428,5.411Z",
    transform: "translate(8.078 31.531)",
    opacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M44.574,67.6A21.269,21.269,0,0,1,34.45,69.918c-11.751,0-19.054-7.3-19.054-19.054V49.721a2.866,2.866,0,0,1,.089-.7v-.291a4.262,4.262,0,0,1,.171-.929h0a4.276,4.276,0,0,1,.286-1.089v-.171q.144-.482.3-.965v-.2a72.559,72.559,0,0,1,7.982-15.145h0c2.661-4.053,5.661-8.126,8.589-11.822v-.092c1.792-2.858,3.575-5.589,5.49-8.107L36.948,8.63h0l-1.7-2.465a1.089,1.089,0,0,0-1.644,0L31.662,8.486C29.233,11.279,8,36.024,8,50.811,8,66.887,18.376,77.242,34.431,77.242A28.127,28.127,0,0,0,49.95,73.009,13.3,13.3,0,0,1,44.575,67.6Z",
    transform: "translate(-8 4.555)",
    fill: "#a12697"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M30.917,43.948a25.68,25.68,0,0,1-3.571-8.822c-.446-.214-.876-.446-1.286-.684a25.985,25.985,0,0,0,3.465,9.215Z",
    transform: "translate(6.193 27.07)",
    fill: "#00aee0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M30.917,43.948a25.68,25.68,0,0,1-3.571-8.822c-.446-.214-.876-.446-1.286-.684a25.985,25.985,0,0,0,3.465,9.215Z",
    transform: "translate(6.193 27.07)",
    opacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M61.481,23.075c-1.786-2.964-3.787-5.8-5.661-8.394C51.356,8.524,47.337,3.822,46.355,2.709l-2-2.386a.929.929,0,0,0-1.411,0L40.872,2.7c-.982,1.125-5.018,5.839-9.484,12-1.786,2.518-3.7,5.251-5.483,8.108-4.714,7.553-8.7,15.846-8.7,22.268,0,13.511,7.354,23,19.27,25.654a25.984,25.984,0,0,1-3.465-9.215c-5.358-3.108-8.428-8.84-8.428-16.448,0-4.411,3.055-11,7.286-17.859,1.358-2.215,2.822-4.358,4.339-6.537,2.179-3.108,4.483-6.157,6.751-8.929a.893.893,0,0,1,1.368,0c2.251,2.8,4.554,5.839,6.733,8.929,1.519,2.16,2.983,4.358,4.322,6.537,4.25,6.875,7.3,13.465,7.3,17.859,0,8.233-3.571,14.286-9.786,17.161a25.654,25.654,0,0,1-3.571,8.8c12.75-2.2,20.715-11.893,20.715-25.948C70.07,38.719,66.177,30.557,61.481,23.075Z",
    transform: "translate(-0.762 0.002)",
    fill: "#00aee0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(700.044 525.201)",
    style: {
      isolation: "isolate"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M10.91,53.7a7.037,7.037,0,0,1,5.372,2.091,11.2,11.2,0,0,1,0,12.758,7.037,7.037,0,0,1-5.372,2.091H7.343a7.037,7.037,0,0,1-5.372-2.091,11.308,11.308,0,0,1,0-12.75A7.037,7.037,0,0,1,7.339,53.7ZM7.66,56.972a3.948,3.948,0,0,0-3.223,1.209,6.231,6.231,0,0,0-1.021,3.975,6.15,6.15,0,0,0,1.021,3.948A3.975,3.975,0,0,0,7.66,67.315h2.927a3.975,3.975,0,0,0,3.223-1.209,6.15,6.15,0,0,0,1.021-3.948,6.231,6.231,0,0,0-1.021-3.975,3.948,3.948,0,0,0-3.223-1.209Z",
    transform: "translate(0.004 -41.07)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M11.748,51.32v3.948H8.31V51.32Zm0,6.4V74.634H8.31V57.712Z",
    transform: "translate(14.019 -45.06)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M14.774,51V75.174H11.39V51Z",
    transform: "translate(19.212 -45.6)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M16.14,58.242v-1.5a11.414,11.414,0,0,1,.3-2.686,4.189,4.189,0,0,1,.887-1.8,3.357,3.357,0,0,1,1.558-.967,7.79,7.79,0,0,1,2.256-.3h3.034v3.116H21.834a2.364,2.364,0,0,0-1.745.538,2.873,2.873,0,0,0-.538,1.988v1.693h4.674V61.6H19.658V75.191H16.14V61.519H13.83V58.242Z",
    transform: "translate(23.325 -45.617)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M22.379,51.32v3.948H18.935V51.32Zm0,6.4V74.634H18.935V57.712Z",
    transform: "translate(31.939 -45.06)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M33.262,53.7a5.936,5.936,0,0,1,4.351,1.37,5.21,5.21,0,0,1,1.343,3.841,4.781,4.781,0,0,1-1.289,3.68,6.258,6.258,0,0,1-4.428,1.262H25.177v1.209a2.417,2.417,0,0,0,.59,1.693,2.686,2.686,0,0,0,2.015.645H38.15v3.25H27.782a7.736,7.736,0,0,1-2.684-.431,4.835,4.835,0,0,1-1.827-1.182,4.459,4.459,0,0,1-1.048-1.772A7.332,7.332,0,0,1,21.9,65.04V59.291a7.359,7.359,0,0,1,.322-2.2,4.459,4.459,0,0,1,1.048-1.772A4.888,4.888,0,0,1,25.1,54.135a7.736,7.736,0,0,1,2.686-.429ZM25.2,61.118h8.058A2.686,2.686,0,0,0,35.2,60.58a1.961,1.961,0,0,0,.4-1.476,2.068,2.068,0,0,0-.565-1.531,2.5,2.5,0,0,0-1.827-.59H27.836a2.686,2.686,0,0,0-2.015.672,2.417,2.417,0,0,0-.59,1.665Z",
    transform: "translate(36.931 -41.079)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M33.194,51V75.174H29.81V51Z",
    transform: "translate(50.266 -45.6)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M50.833,51V67.921a8.058,8.058,0,0,1-1.584,5.372,5.882,5.882,0,0,1-4.62,1.772h-4.7a7.037,7.037,0,0,1-5.372-2.091,11.308,11.308,0,0,1,0-12.758,7.037,7.037,0,0,1,5.372-2.091H47.4V51ZM43.608,71.977a3.787,3.787,0,0,0,2.927-.967,4.647,4.647,0,0,0,.861-3.143V61.5H40.251a3.948,3.948,0,0,0-3.223,1.209,6.231,6.231,0,0,0-1.021,3.975,6.15,6.15,0,0,0,1.021,3.948,3.975,3.975,0,0,0,3.223,1.209Z",
    transform: "translate(54.946 -45.6)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M58.309,49.017a12.915,12.915,0,0,1,9.91,3.675,15.874,15.874,0,0,1,3.444,11.174A15.632,15.632,0,0,1,68.22,74.959a13,13,0,0,1-9.912,3.6H54.28a13,13,0,0,1-9.912-3.626,15.605,15.605,0,0,1-3.331-11.092,15.846,15.846,0,0,1,3.444-11.174,12.915,12.915,0,0,1,9.8-3.653Zm-4.03,5.151a7.789,7.789,0,0,0-6.231,2.283,11.335,11.335,0,0,0-1.961,7.413,11.12,11.12,0,0,0,1.929,7.311,7.872,7.872,0,0,0,6.258,2.229H58.3a7.763,7.763,0,0,0,6.2-2.256,11.147,11.147,0,0,0,1.961-7.332,11.335,11.335,0,0,0-1.934-7.359,7.736,7.736,0,0,0-6.225-2.289Z",
    transform: "translate(69.093 -48.99)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M78.292,49v5.166H63.117a3.841,3.841,0,0,0-2.927.984,3.545,3.545,0,0,0-.913,2.525,4.35,4.35,0,0,0,.187,1.288,2.686,2.686,0,0,0,.7,1.128,3.444,3.444,0,0,0,1.343.779,6.822,6.822,0,0,0,2.149.3h6.929a13.564,13.564,0,0,1,4.942.779,8.058,8.058,0,0,1,3.034,1.988,6.608,6.608,0,0,1,1.531,2.686,12.276,12.276,0,0,1,.431,3.256,10.9,10.9,0,0,1-.538,3.465,7.037,7.037,0,0,1-1.665,2.686,7.816,7.816,0,0,1-2.9,1.827,12.488,12.488,0,0,1-4.325.669H54.629V73.367H71.282a4.11,4.11,0,0,0,3.089-1.021,3.653,3.653,0,0,0,.994-2.686,4.428,4.428,0,0,0-.215-1.37,2.686,2.686,0,0,0-.752-1.182,3.813,3.813,0,0,0-1.423-.806,7.091,7.091,0,0,0-2.256-.3H63.843a13.429,13.429,0,0,1-4.808-.752,7.466,7.466,0,0,1-2.952-1.961,6.849,6.849,0,0,1-1.476-2.686,11.629,11.629,0,0,1-.4-3.062,10.958,10.958,0,0,1,.51-3.384,6.742,6.742,0,0,1,1.611-2.686A7.547,7.547,0,0,1,59.037,49.6,12.436,12.436,0,0,1,63.3,49Z",
    transform: "translate(91.385 -48.978)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOosProducts);
export default __webpack_public_path__ + "static/media/oos-products.600d44989e19c1a8375ec519e2afb525.svg";
export { ForwardRef as ReactComponent };